import { type DatabaseSnapshot } from '@/entities/database';
import request from '@/shared/api/request';

export const createDatabaseSnapshot = (
  uuid: string,
  name: string,
): Promise<{ snapshot: DatabaseSnapshot }> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'snapshot', name },
  });
